import API from '@/api/api.js'
import Moment from 'moment';

export default class AuthAPIList {
  constructor() {
    let api = new API();
    this.api = api;
  }

  login(param, success, error) {
    this.api.post('/auth/login', param,
      (json) => {
        success(json);
      }, (err) => {
        error(err);
      });
  }
  register(param, success, error) {
    this.api.post('/auth/register', param,
      (json) => {
        success(json);
      }, (err) => {
        error(err);
      });
  }
  sendCode(param, success, error) {
    this.api.post('/auth/sendCode', param,
      (json) => {
        success(json);
      }, (err) => {
        error(err);
      });
  }
  verifyMobile(param, success, error) {
    this.api.post('/auth/verifyMobile', param,
      (json) => {
        success(json);
      }, (err) => {
        error(err);
      });
  }
    createTmpToken(param, success, error) {
    this.api.post('/auth/createToken', param,
      (json) => {
        success(json);
      }, (err) => {
        error(err);
      });
  }
  forgetPassword(param, success, error) {
    this.api.post('/auth/forgetPassword', param,
      (json) => {
        success(json);
      }, (err) => {
        error(err);
      });
  }
  sendOneTimePassword(param, success, error) {
    this.api.post('/auth/sendOneTimePassword', param,
      (json) => {
        success(json);
      }, (err) => {
        error(err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/Auth/apiList.js